export default __webpack_public_path__ + "static/media/use_congress.29633d9a.png";